import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  isStale: true,
  latest_fetch: '',
  type: 'animalTypeRegion',
  pageLayout: 'LayoutStructureTable',
  canEdit: false,
  canView: false,
  inlineEdit: true,
  modelLabels: {
    single: 'Specie & Region Pair',
    plural: 'Specie & Region Pairs'
  },
  filterOverrides: [],
  aliasField: 'title',
  relations: [
    {
      name: 'files',
      translate: 'files',
      label: 'files',
      value: 'files',
      storename: 'files',
      export: false
    },
    {
      name: 'regions',
      translate: 'regions',
      label: 'Regions',
      value: 'regions',
      storename: 'regions',
      export: false
    },
    {
      name: 'animalTypes',
      translate: 'animalTypes',
      label: 'Animal Types',
      value: 'animalTypes',
      storename: 'animalTypes',
      export: false
    }
  ],
  all: {},
  active: false,
  searchFields: [],
  bound: {
  },
  filter: {},
  quickFilters: [],
  stub: { files: {} },
  include: ''
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
